<template>
    <div class="activate-package">
        <div class="bg-imgs">
            <img src="https://tc-nj-backend-ms-pub-cdn.mobvoi.com/moyin-mp-cdn/cdnData//images/superclone/3s_SKU_bg1.png"
                alt="" />
        </div>
        <div class="content">
            <div class="title">3秒克隆</div>
            <div class="sub-title">大模型加持完美还原音色，让您秒变专业解说大咖</div>
            <div class="price-box">
                <img class="bg-img2"
                    src="https://tc-nj-backend-ms-pub-cdn.mobvoi.com/moyin-mp-cdn/cdnData/images/superclone/3s_SKU_bg.png"
                    alt="" />
                <div class="price-content">
                    <div class="current-price">
                        ￥
                        <span>{{ (priceInfo.price / 100).toFixed(2) }}</span>
                        <div class="tag" v-if="tagTxt">
                            {{ tagTxt }}
                        </div>
                    </div>
                    <div class="original-price">
                        ￥
                        <span>{{ (priceInfo.originalPrice / 100).toFixed(2) }}</span>
                    </div>
                </div>
            </div>
            <div class="white-block">
                <!-- 支付方式 -->
                <div class="pay-tools">
                    <div class="title-text">支付方式</div>
                    <div class="pay-list">
                        <div class="pay-item" :class="{ selected: selectedPayType === item.payType }"
                            v-for="item in PAY_TOOL_LIST" :key="item.name" @click="onSwitchPayType(item)">
                            <img class="icon"
                                :src="`https://tc-nj-backend-ms-pub-cdn.mobvoi.com/rd2-cdn/moyin-mini/associate-member/${item.icon}`"
                                alt="">
                            <div class="name">{{ item.name }}</div>
                        </div>
                    </div>
                </div>

                <div class="phone-info">
                    <div class="title-text">手机号<span class="tip">权益绑定到如下手机号上</span></div>
                    <div class="phone-input">{{ formatPhone(phone) }}</div>
                </div>

                <div class="buy-notices">
                    <div class="notice-title">购买须知</div>
                    <div class="notice-items">
                        <div class="notice-item">
                            1.开通服务即激活1个声音ID，获得权益：5次克隆机会（提交审核前可用）、5w克隆发音人合成字数、80合成次数/天，托管费有效期内
                            试听不限次数。
                        </div>
                        <div class="notice-item">
                            2.声音ID激活后，首年免托管费；次年起每个声音ID每年需要缴纳49元托管费。
                        </div>
                        <div class="notice-item">3.有效期1年，多次购买字数可叠加。</div>
                        <div class="notice-item">4.开通服务后不支持退款。</div>
                        <div class="notice-item">
                            5.如有其他问题，请通过魔音小程序联系客服。
                        </div>
                    </div>
                </div>

                <!-- 暂时没有h5专门会员页 -->
                <!-- <div class="buy-cards">
                    <div class="card-item" @click="jumpToVip('svip')">
                        <div class="card-text">
                            全场声音会员用户，享优惠价
                            <span class="red-price">
                                ￥{{ priceInfo.allPackageVipPriceForDisplay / 100 }}
                            </span>
                        </div>
                        <img class="icon-arrow"
                            src="https://tc-nj-backend-ms-pub-cdn.mobvoi.com/moyin-mp-cdn/cdnData/images/superclone/right-arrow.png"
                            alt="" />
                    </div>
                    <div class="card-item" @click="jumpToVip('vip')">
                        <div class="card-text">
                            会员用户，享优惠价
                            <span class="red-price">￥{{ priceInfo.vipPriceForDisplay / 100 }}</span>
                        </div>
                        <img class="icon-arrow"
                            src="https://tc-nj-backend-ms-pub-cdn.mobvoi.com/moyin-mp-cdn/cdnData/images/superclone/right-arrow.png"
                            alt="" />
                    </div>
                </div> -->
            </div>
        </div>


        <div class="page-bottom-btn">
            <div class="agree-btn" @click="onPayConfirm">
                同意协议并支付 ¥{{ priceInfo.price / 100 }}
            </div>
            <div class="notice-txt">
                支付即代表您已阅读并同意 <span class="protocol-link"
                    @click="jumpToProtocol(`${protocolUrlHost}/protocol`)">《用户协议》</span> 和 <span class="protocol-link"
                    @click="jumpToProtocol(`${protocolUrlHost}/privacy`)">《隐私协议》</span>
            </div>
        </div>
    </div>
</template>
<script>
import to from "await-to-js"
import { create3sCloneOrder, get3sClonePayInfoByKey, get3sPayResult } from '@/api/3sClone';
import { toast } from '@/utils/util';
import { Toast } from 'vant'
import { PAY_STATUS, callPay, getWxJsCode, showPayConfirm } from "@/utils/pay";
import { judgeDeviceType } from "@/utils/device";
import { isWeiXin } from "@/utils/open-download-app";

const PAY_TOOL_LIST = [{
    name: '微信支付',
    icon: 'wechat.png',
    payType: 'wxpayH5'
}, {
    name: '支付宝支付',
    icon: 'alipay.png',
    payType: 'alipayH5'
}]
const PAGE_INFO_CACHE = '__buy3s_clone_page_info'
export default {
    data() {
        return {
            PAY_TOOL_LIST,
            priceInfo: {
                price: 0,
                originalPrice: 0,
                vipPriceForDisplay: 0,
                allPackageVipPriceForDisplay: 0
            },
            vipInfo: {
                realVip: false,
                isAllPackageVip: false
            },
            orderRequest: null,
            payInfo: null,
            phone: '',
            jsCode: '', // 微信公众号支付订单使用
            selectedPayType: 'wxpayH5',
            protocolUrlHost: `${location.origin}/#`
        }
    },
    computed: {
        tagTxt() {
            const { realVip, isAllPackageVip } = this.vipInfo
            return !realVip ? '' : !isAllPackageVip ? '会员优惠价' : '全场声音会员优惠价';
        }
    },
    created() {
        if (isWeiXin()) {
            this.jsCode = getWxJsCode()
            try {
                const str = localStorage.getItem(PAGE_INFO_CACHE)
                localStorage.removeItem(PAGE_INFO_CACHE)
                this.pageInfoCache = JSON.parse(str)
            } catch { }
        }

        this.getPageInfo();

        showPayConfirm({
            onPayComplete: this.handlePayStatus
        })
    },
    beforeDestroy() {
        clearTimeout(this.getPayResultTimer)
    },
    methods: {
        formatPhone(phone) {
            if (!phone) return ''
            return `${phone.slice(0, 3)} ${phone.slice(3, 7)} ${phone.slice(7)}`;
        },
        async getPageInfo() {
            const [err, resp] = this.pageInfoCache ? [null, this.pageInfoCache] : await to(get3sClonePayInfoByKey({
                key: this.$route.params.code
            }))
            const res = resp?.data || {}
            console.log('页面配置:', res)
            if (err || res.code !== 200) {
                toast('获取订单信息出错')
                return
            }

            if (isWeiXin()) { // 微信获取code，第二次回来页面不用重复请求数据了 // todo 应该把获取code票据放在点击支付按钮时
                localStorage.setItem(PAGE_INFO_CACHE, JSON.stringify(resp))
            }

            this.phone = res.data.phone
            this.vipInfo = JSON.parse(res.data.vipInfo)
            this.orderRequest = JSON.parse(res.data.orderRequest)
            this.priceInfo = JSON.parse(res.data.price)
        },
        onSwitchPayType(item) {
            this.selectedPayType = item.payType
        },
        async onPayConfirm() {
            if (this.selectedPayType === 'wxpayH5' && isWeiXin() && !this.jsCode) {
                toast('code票据不存在')
                return
            }
            const loading = Toast.loading({
                message: '加载中',
                mask: true
            })

            // 创建订单
            const [err, resp] = await to(create3sCloneOrder({
                jsCode: this.jsCode,
                payMethod: this.selectedPayType === 'alipayH5' ? 'h5Alipay' : this.selectedPayType,
                // ww_token: getLocalStorage('token'),
                phone: this.phone,
                device: judgeDeviceType.isIOS ? 'H5_IOS' : "H5_ANDROID",
                type: this.orderRequest.type,
                taskId: this.orderRequest.taskId,
            }))
            const res = resp?.data || {}
            console.log('订单数据:', res)
            if (err || res.code !== 200 || !res.data) {
                toast((res.message === "未获取到openId" ? "请在微信客户端打开链接" : res.message === 'OK' ? "" : res.message) || '创建订单出错')
                return
            }

            this.payInfo = res.data;
            // 唤起支付
            callPay({
                payParams: this.payInfo.payParams,
                payType: this.selectedPayType,
                onPayComplete: this.handlePayStatus
            })

            loading.clear();
        },
        // 获取支付结果
        handlePayStatus({ payStatus, payParams }) {
            if (payStatus === PAY_STATUS.FAIL) {
                return
            }
            if (payStatus === PAY_STATUS.SUCC) {
                this.jumpToSucc()
                return
            }

            // this.jumpToSucc()
            this.checkPayResult({ payParams });
        },
        async checkPayResult({ payParams }) {
            // clearTimeout(this.getPayResultTimer);
            // this.getPayResultTimer = setTimeout(async () => {
            const [err, resp] = await to(get3sPayResult({
                orderId: payParams.orderId,
                type: 'ACTIVATE'
            }))
            const res = resp?.data || {}
            console.log('支付结果:', res)
            if (err || res.code !== 200) {
                toast('获取购买状态出错')
                console.log('获取购买状态出错', err)
                return
            }
            if (res.data) {
                this.jumpToSucc();
            } else {
                toast('未支付，请重新支付')
            }

            //     this.getPayStatus()
            // }, 3000)
        },
        jumpToSucc() {
            this.$router.push(`/buy3sCloneSuccess?phoneNumber=${this.phone}`)
        },
        jumpToProtocol(url) {
            window.open(url, '_blank')
        }
    }
}

</script>
<style lang="less" scoped>
.fc {
    display: flex;
    align-items: center;
    justify-content: center;
}

.activate-package {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #f5f6f7;

    .bg-imgs {
        position: absolute;
        top: 0;
        left: 0;
        width: 750px;
        height: 812px;

        img {
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    .content {
        flex: 1;
        overflow: auto;
        position: relative;
        padding-bottom: 260px;

        // z-index:11;
        .title {
            font-size: 56px;
            color: #001126;
            line-height: 72px;
            text-align: left;
            font-style: normal;
            font-family: HarmonyOS_Sans_SC_Medium;
            margin: 32px 48px 16px;
        }

        .sub-title {
            height: 44px;
            font-family: HarmonyOS_Sans_SC;
            font-size: 28px;
            color: #596472;
            line-height: 44px;
            text-align: left;
            font-style: normal;
            margin: 0px 48px 46px;
        }

        .price-box {
            position: relative;
            width: 100%;

            // margin:0px 24px;
            .bg-img2 {
                // width: calc(100% - 48px);
                // height: 360px;
                width: 702px;
                height: 360px;
                margin: 0 auto;
                position: absolute;
                transform: translateX(-50%);
                left: 50%;
            }

            .price-content {
                position: absolute;
                left: 0;
                top: 56px;
                bottom: 0;
                right: 0;

                .current-price {
                    font-size: 48px;
                    line-height: 68px;
                    color: #ffffff;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    span {
                        font-family: HarmonyOS_Sans_SC_Bold;
                        font-size: 64px;
                        line-height: 92px;
                        color: #ffffff;
                    }

                    .tag {
                        padding: 6px 12px;
                        box-sizing: border-box;
                        background: linear-gradient(270deg, rgba(255, 255, 255, 0.8) 0%, #FFFFFF 100%);
                        border-radius: 200px 200px 200px 4px;
                        border: 2px solid #FFFFFF;
                        font-family: HarmonyOS_Sans_SC_Medium;
                        font-size: 24px;
                        color: #FE5050;
                        line-height: 40px;
                        text-align: center;
                        margin-left: 16px;
                    }
                }

                .original-price {
                    font-family: HarmonyOS_Sans_SC;
                    font-size: 40px;
                    color: #ffffff;
                    line-height: 56px;
                    text-decoration-line: line-through;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }

            // .tag{
            //   position:absolute;
            //   right:0;
            //   top:10px;
            // }
        }

        .white-block {
            margin: 300px 24px 0px;
            background: #fff;
            padding: 14px 32px 32px;


            .pay-tools {
                position: relative;

                .title-text {
                    margin-bottom: 16px;
                    font-family: HarmonyOS_Sans_SC_Medium;
                    font-size: 28px;
                    color: #001126;
                    line-height: 44px;
                }

                .pay-list {
                    display: flex;
                }

                .pay-item {
                    .fc();
                    flex: 1;
                    box-sizing: border-box;
                    height: 88px;
                    background: #FFFFFF;
                    border-radius: 16px;
                    border: 2px solid #DDE1EA;

                    &+.pay-item {
                        margin-left: 22px;
                    }

                    .icon {
                        width: 48px;
                        height: 48px;
                    }

                    .name {
                        margin-left: 16px;
                        font-family: HarmonyOS_Sans_SC;
                        font-size: 28px;
                        color: #596472;
                        line-height: 44px;
                    }



                    &.selected {
                        border: none;
                        padding: 4px;
                        background: linear-gradient(217deg, #FFF3F8 0%, #EDEEFA 100%), linear-gradient(215deg, rgba(227, 105, 121, 1), rgba(0, 110, 255, 1), rgba(61, 94, 215, 1));
                        background-clip: content-box, border-box;

                        .name {
                            font-family: HarmonyOS_Sans_SC_Medium;
                            color: #006EFF;
                        }
                    }
                }
            }

            .phone-info {
                margin-top: 32px;

                .title-text {
                    margin-bottom: 16px;
                    font-family: HarmonyOS_Sans_SC_Medium;
                    font-size: 28px;
                    color: #001126;
                    line-height: 44px;

                    .tip {
                        margin-left: 8px;
                        font-family: HarmonyOS_Sans_SC;
                        font-size: 24px;
                        color: #596472;
                        line-height: 40px;
                    }
                }

                .phone-input {
                    display: flex;
                    align-items: center;
                    padding: 0 16px;
                    box-sizing: border-box;
                    width: 638px;
                    height: 88px;
                    background: #F5F8FD;
                    border-radius: 16px;
                    border: 2px solid #DDE1EA;

                    font-family: HarmonyOS_Sans_SC_Medium;
                    font-size: 28px;
                    color: #001126;
                }
            }

            .buy-notices {
                margin-top: 32px;
                position: relative;
                background: transparent;

                .notice-title {
                    font-family: HarmonyOS_Sans_SC_Medium;
                    font-size: 36px;
                    color: #001126;
                    line-height: 52px;
                    // margin: 0px 32px;
                    // padding-top: 40px;
                }

                .notice-items {
                    background: #ffffff;


                    .notice-item {
                        color: #596472;
                        line-height: 44px;
                        font-size: 28px;
                        display: flex;
                        margin-top: 16px;

                        span {
                            color: #006eff;
                        }
                    }
                }
            }

            .buy-cards {
                display: flex;
                justify-content: space-between;
                margin-top: 80px;

                .card-item {
                    width: 308px;
                    height: 120px;
                    box-sizing: border-box;
                    padding: 16px 24px;
                    background: linear-gradient(135deg, #F1F7FF 0%, #FFFFFF 100%);
                    border-radius: 24px;
                    border: 2px solid #E2E8F5;
                    font-size: 24px;
                    line-height: 44px;

                    position: relative;
                    display: flex;
                    flex-wrap: wrap;

                    .red-price {
                        color: #FE5050;
                        font-size: 28px;
                    }

                    .card-text {
                        color: #596472;
                    }

                    .icon-arrow {
                        width: 32px;
                        height: 32px;
                        position: absolute;
                        right: 24px;
                        bottom: 24px;
                    }
                }
            }
        }
    }

    .page-bottom-btn {
        position: fixed;
        text-align: center;
        padding: 25px 0 50px 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        background: #ffffff;
        box-shadow: 0px 0px 32px 0px #F0F1F3;
        display: flex;
        flex-direction: column;
        align-items: center;

        .txt-center {
            text-align: center;
            margin: 10px 0px;
            color: #FF8300;
            font-size: 24px;
        }

        .payBtn {
            outline: none;
            border: none;
            width: 640px;
            height: 84px;
            border-radius: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            font-family: HarmonyOS_Sans_SC_Medium;
            color: #91560F;
            font-size: 30px;
            font-family: HarmonyOS_Sans_SC_Bold;
            color: #FFFFFF;
            line-height: 42px;
            background: linear-gradient(90deg, #000000 0%, #D72D6C 70%, #9B003A 100%);
        }

        .agree-btn {
            width: 640px;
            height: 88px;
            margin-top: 24px;
            background: #FE5050;
            border-radius: 44px;
            font-family: HarmonyOS_Sans_SC_Medium;
            font-size: 28px;
            color: #FFFFFF;
            line-height: 88px;
            text-align: center;
        }

        .notice-txt {
            font-size: 24px;
            font-family: HarmonyOS_Sans_SC;
            color: #666666;
            margin-top: 12px;
            height: 40px;
            text-align: center;

            span {
                color: #263446;
            }
        }
    }
}
</style>